<template>
	<div class="view college-view  has-footer">
		<HeaderBar @search="onSearch"
				   @clear="onClear" />
		<NavBar :subItemList="subItemList"
				:fixedItemList="fixedNavItemList"
				:itemList="navItemList"
				:selectedItemId="selectedNavItem"
				:onItemClick="onNavItemClick"
				:noManage="true" />
		<div class="view__wrap">
			<div class="tag-list-wrap"
				 v-show="selectedNavItem !== defaultCateId">
				<div class="btn-wrap">
					<van-button size="mini"
								:plain="selectedFormat !== 1"
								type="primary"
								class="tag-btn"
								@click="onFormatTagClick(selectedTag, 1)">
						PDF
					</van-button>
					<van-button size="mini"
								:plain="selectedFormat !== 2"
								type="primary"
								class="tag-btn"
								@click="onFormatTagClick(selectedTag, 2)">
						视频
					</van-button>
				</div>
				<div class="tag-list">
					<!-- <TagItem class v-bind="{id: 1, name: 'PDF'}" :isSmall="true" :isPrimary="selectedFormat === 1" @click.native="onSubTagClick(selectedTag, 1)"/>
      <TagItem class v-bind="{id: 2, name: '视频'}" :isSmall="true" :isPrimary="selectedFormat === 2" @click.native="onSubTagClick(selectedTag, 2)"/> -->
					<div class="tag-list--inner">
						<TagItem v-for="item in subCateList"
								 :key="item.id"
								 v-bind="item"
								 :autoWidth="true"
								 :isPlain="true"
								 :isPrimary="item.id === selectedTag"
								 @click.native="onSubTagClick(item.id, selectedFormat)" />
					</div>

				</div>
			</div>
			<van-pull-refresh v-model="isRefreshing"
							  @refresh="onRefresh">
				<van-swipe ref="swipe" @change="onSwipeChange"
						   :loop="false"
						   :show-indicators="false">
					<van-swipe-item v-for="item in mergedNavItemList"
									:key="item.id" 
									infinite-scroll-distance="80" 
									v-infinite-scroll="loadMore"
									:infinite-scroll-disabled="bottomLoading"
								>
						<Index v-if="selectedNavItem===defaultCateId && isSearch===false"
							   :bannerList="bannerList"
							   :latestCourseList="latestCourseList"
							   :recommCourseList="recommCourseList"
							   :hotCourseList="hotCourseList" />
						<Other v-else
							   :courseList="recommCourseList"  />
					</van-swipe-item>
					<!-- <van-swipe-item 
			  v-else >
						<Index v-if="selectedNavItem===defaultCateId && isSearch===false"
							   :bannerList="bannerList"
							   :latestCourseList="latestCourseList"
							   :recommCourseList="recommCourseList"
							   :hotCourseList="hotCourseList" />
						<Other v-else
							   :courseList="recommCourseList"  />
					</van-swipe-item> -->


				</van-swipe>
			</van-pull-refresh>
		</div>

		<PopLoading v-show="isLoading" />

	</div>
</template>
<script>
import { Button, Swipe, SwipeItem } from 'vant';
import apiUtil from '../../utils/apiUtil';
import { scrollToLeft } from '../../utils/globalUtil'
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
import NavBar from '../../components/NavBar';
import TagItem from '../../components/TagItem';
import PopLoading from '../../components/PopLoading';

import Index from './Index.vue';
import Other from './Other.vue'
export default {
	name: 'college',
	components: {
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		'van-button': Button,
		HeaderBar,
		NavBar,
		TagItem,
		PopLoading,

		Index,
		Other
	},
	data() {
		return {
			defaultCateId: 0,
			selectedNavItem: 0,
			selectedTag: 0,
			selectedFormat: 0,
			bannerList: [],
			fixedNavItemList: [],
			navItemList: [],
			mergedNavItemList:[],
			subCateList: [],
			latestCourseList: [],
			recommCourseList: [],
			hotCourseList: [],
			subItemList: [],
			isSearch: false,
			isLoading: false,
			isRefreshing: false,
			page: 1,
			bottomLoading: false,
			loadFinished: false

		};
	},
	created() {
		this.init();
		this.getSubCate();
	},
	watch: {
		'$route'(to, from) {
			const { cate_id, sub_id, subfix } = to.query;
			if (!cate_id) {
				this.initIndexView();
			} else {
				this.getCollegeOther(cate_id, sub_id, subfix)
				this.selectedNavItem = parseInt(cate_id);
				this.selectedTag = sub_id ? parseInt(sub_id) : 0;
				this.selectedFormat = subfix ? parseInt(subfix) : 0
			}
		}
	},
	methods: {
		init(isDragDown = false) {
			const { cate_id, sub_id, subfix } = this.$route.query;
			if (!cate_id) {
				this.initIndexView(isDragDown);
			} else {
				this.getCollegeOther(cate_id, sub_id, subfix, isDragDown)
				this.selectedNavItem = parseInt(cate_id);
				this.selectedTag = sub_id ? parseInt(sub_id) : 0;
				this.selectedFormat = subfix ? parseInt(subfix) : 0;
				this.loadFinished=false;
			}
		},
		loadMore() {
			if(!this.loadFinished){
				this.bottomLoading = true;
				const { cate_id, sub_id, subfix } = this.$route.query;
				this.page=this.page+1;
				if(cate_id){
					this.getCollegeOtherMore(cate_id, sub_id, subfix,this.page);
				}
			}
			
		},
		onSwipeChange(index) {
			this.subCateList = [];
			this.loadFinished=false;
			if (index >= this.fixedNavItemList.length) {
				const id = this.navItemList[index - this.fixedNavItemList.length].id;
				this.selectedNavItem = id;
				const navItem = this.navItemList.find(ele => ele.id === id)
				this.subCateList = navItem.sub_cate.map(ele => {
					ele.name = ele.cate_name;
					return ele;
				});
				this.$router.push({
					name: 'college',
					query: {
						cate_id: id,
						sub_id: 0,
						subfix: 0
					}
				})
				this.navItemScrollToView(id)

				// this.selectedTag = 0;
				// this.selectedFormat = 0;
				// this.getCollegeOther(id, 0, 0)
			} else {
				const id = this.fixedNavItemList[index].id;
				this.selectedNavItem = id;
				// this.initIndexView();
				this.$router.push({
					name: 'college'

				})

			}


			// const id = this.navItemList[index].id;
			// this.selectedNavItem = id;
			// if (id !== this.defaultCateId) {
			//   this.subCateList = this.navItemList
			//     .find(ele => ele.id === id)
			//     .sub_cate.map(ele => {
			//       ele.name = ele.cate_name;
			//       return ele;
			//     });
			//   this.getCollegeOther(id);
			// } else {
			//   this.subCateList = []
			//   this.initIndexView();
			// }
		},

		navItemScrollToView(id) {
			const navItem = this.$el.querySelector('#navItem_' + id);
			const wrapper = this.$el.querySelector('#navListNormal');

			if (navItem) {

				scrollToLeft(wrapper, navItem.offsetLeft, 200)

			}
		},

		onNavItemClick(item, index) {
			this.onSwipeChange(index);
			this.$refs['swipe'].swipeTo(index);
		},

		async initIndexView(isDragDown = false) {
			if (!isDragDown) {
				this.isLoading = true;

			}
			const res = await apiUtil.post(apiConst.getCollegeIndex);
			this.isRefreshing = false;
			this.isLoading = false;
			if (res) {
				const { home_banner, study } = res;
				this.bannerList = home_banner;
				if (study.hasOwnProperty('latest')) {
					this.latestCourseList = study.latest;
				}
				if (study.hasOwnProperty('recommend')) {
					this.recommCourseList = study.recommend;
				}
				if (study.hasOwnProperty('play_list')) {
					this.hotCourseList = study.play_list;
				}
			}
		},
		async getCollegeOtherMore(id, sub_id = 0, subfix = 0,page=1,pagesize=10) {
			this.isLoading = true;
			this.bottomLoading = true;
			const res = await apiUtil.post(apiConst.getCollegeOther, {
				cate_id: id,
				sub_id: !sub_id ? 0 : sub_id,
				subfix: !subfix ? 0 : subfix,
				page:page,
				pagesize:pagesize
			});
			this.isLoading = false;
			this.bottomLoading = false;
			this.isRefreshing = false;
			if (res) {
				const { list } = res;

				this.latestCourseList = [];

				for(let item of list){
		          if(this.recommCourseList.findIndex(ele => ele.id === item.id) === -1){
		            this.recommCourseList = this.recommCourseList.concat(item)
		          }
		        }
				if(list.length < this.pagesize){
					this.loadFinished = true;
				}

				this.hotCourseList = [];
			}
		}, 
		async getCollegeOther(id, sub_id = 0, subfix = 0) {
			this.isLoading = true;
			const res = await apiUtil.post(apiConst.getCollegeOther, {
				cate_id: id,
				sub_id: !sub_id ? 0 : sub_id,
				subfix: !subfix ? 0 : subfix
			});
			this.isLoading = false;

			this.isRefreshing = false;
			if (res) {
				const { list } = res;

				this.latestCourseList = [];

				this.recommCourseList = list;

				this.hotCourseList = [];
				this.page=1;
				this.bottomLoading=false;
			}
		},

		async getSubCate() {
			const res = await apiUtil.post(apiConst.getSubCate, {});
			if (res.success) {
				const { group_a, group_b } = res.category;
				this.fixedNavItemList = group_a;
				this.navItemList = group_b;
				this.mergedNavItemList = group_a.concat(group_b);
				if (group_a.length > 0 && this.selectedNavItem === 0) {
					this.defaultCateId = group_a[0].id;
					this.selectedNavItem = group_a[0].id;
				}
			}
		},

		onSubTagClick(id, formatId = 0) {
			this.loadFinished = false;
			if (this.selectedTag === id) {
				this.$router.push({					name: 'college', query: {
						cate_id: this.selectedNavItem,
						sub_id: 0,
						subfix: formatId
					}				})
			} else {
				this.$router.push({					name: 'college', query: {
						cate_id: this.selectedNavItem,
						sub_id: id,
						subfix: formatId
					}				})

			}

		},

		onFormatTagClick(sub_id, formatId) {
			if (this.selectedFormat === formatId) {
				// this.selectedFormat = 0; // 反选文件格式
				this.$router.push({					name: 'college', query: {
						cate_id: this.selectedNavItem,
						sub_id,
						subfix: 0
					}				})
				// this.getCollegeOther(this.selectedNavItem, subId, 0);
			} else {
				this.$router.push({					name: 'college', query: {
						cate_id: this.selectedNavItem,
						sub_id,
						subfix: formatId
					}				})

			}
		},

		async onSearch(str) {
			// if (str) {
			// 	this.latestCourseList = [];

			// 	this.recommCourseList = [];

			// 	this.hotCourseList = [];
			// 	this.isSearch = true;
			// 	const res = await apiUtil.post(apiConst.getSearch, {
			// 		keyword: str,
			// 		type: 3
			// 	});
			// 	if (res.success) {
			// 		this.recommCourseList = res.list;
			// 	}
			// } else {
			// 	this.initIndexView();
			// 	this.isSearch = false;
			// }
			this.$router.push({
				name: 'search',
				query: {
					keyword: str,
					type: 3
				}
			})
		},

		onClear() {
			this.isSearch = false;
		},
		onRefresh() {
			this.init(true);
		}
	}
};
</script>
<style lang="stylus">
.college-view {
	position: relative;
	height: 100%;
	/* padding-top: 176px; */

	.nav-bar-comp {
		padding-right: 30px;
	}

	.tag-list-wrap {
		position: relative;
		height: 100px;
		border-top: 1PX solid #f1f1f1;

		.btn-wrap {
			position: absolute;
			left: 30px;
			top: 0;
			height: 100%;
			display: flex;
			align-items: center;

			.tag-btn {
				margin-right: 25px;
				font-size: 28px;
			}
		}

		.tag-list {
			position: absolute;
			height: 100px;
			top: 0;
			left: 292px;
			right: 30px;
			overflow: hidden;
			white-space: nowrap;
			overflow-x: scroll;

			.tag-list--inner {
				display: flex;
				align-items: center;
				height: 100%;

				.tag-item-comp {
					margin-left: 24px;
					flex: none;
				}
			}
		}
	}

	.swiper-view {
		border-top: 13px solid #f1f1f1;

		.news-list {
			padding: 0 15px;
		}

		.banner-img {
			display: block;
			width: 100%;
			height: 100%;
			border-radius: 12px;
		}
	}
}
</style>
